
























































import { Vue, Component } from 'vue-property-decorator';
import { Session } from '../../utils/Session';
import { UserAuthDTO } from '../../../src_server/entity/dto/UserAuthDTO';

import CommonDialog from '../../components/organisms/CommonDialog.vue';
import LessonLabel from './ui/LessonLabel.vue';
import LessonReservationButton from './ui/LessonReservationButton.vue';
import ScrollTopIcon from './ui/ScrollTopIcon.vue';
import LessonPanelTeacherComments from './sections/LessonPanelTeacherComments.vue';
import NewsAndEventSection from './ui/NewsAndEventSection.vue';
import LessonTitleSection from './sections/LessonTitleSection.vue';
import RecentLessonStateSection from './sections/RecentLessonStateSection.vue';
// import LessonRequestDialog from '../lesson_reservation/BKLessonRequestDialog.vue';
import LessonCalendarDialog from '../lesson_reservation/dialog/LessonCalendarDialog.vue';

import { LessonsService } from '../../biz/remote/LessonsService';
import { LessonDTO } from '../../../src_server/entity/dto/LessonDTO';
import { Teacher } from '../../../src_server/entity/generated/Teacher';
import { Lessons } from '../../../src_server/entity/generated/Lessons';
import { dayjs, DT_FORMAT_INPUT, T_FORMAT } from '../../../src_server/common/momentExtends';
import { LessonStates } from '../../../src_server/entity/master/LessonStates';
import EmergencyMessageDialog from '../../components/messages/EmergencyMessageDialog.vue';
import { MessageDialog } from '../../utils/MessageDialog';
import { routeHelper } from '../../utils/routeHelper';
import NoData from './sections/NoData.vue';
import NewsAndEventDialog from './ui/NewsAndEventDialog.vue';

class TeacherLessons {
  teacher?: Teacher;
  lessons: Lessons[] = [];
  get start_dt_f() {
    return dayjs(this.lessons[0].start_dt).format(T_FORMAT);
  }
  get end_dt_f() {
    return dayjs(this.lessons[0].end_dt).format(T_FORMAT);
  }
  get teacherComment() {
    let result = '';
    const recent: Lessons | undefined = this.lessons.find((l) => dayjs(l.start_dt) > dayjs());
    if (recent) {
      result = recent.one_comment || '';
    }
    return result ? result : this.teacher?.default_lesson_comment;
  }

  get all() {
    return this.lessons.length;
  }
  get current() {
    return this.lessons.filter((l) => l.reservation_state === LessonStates.ALREADY).length;
  }
}
@Component({
  components: {
    CommonDialog,
    LessonLabel,
    LessonReservationButton,
    ScrollTopIcon,
    LessonPanelTeacherComments,
    LessonTitleSection,
    NewsAndEventSection,
    RecentLessonStateSection,
    LessonCalendarDialog,
    // LessonRequestDialog,
    EmergencyMessageDialog,
    NoData,
    NewsAndEventDialog,
  },
})
export default class CoDashBoard extends Vue {
  private lessons: LessonDTO[] = [];
  private loading = false;

  get model(): TeacherLessons[] {
    return this.lessons.reduce((prev: TeacherLessons[], curr: LessonDTO) => {
      const inPrevFound = prev.find((i) => i.teacher?.user_id === curr.teacher?.user_id);
      if (inPrevFound) {
        inPrevFound.lessons.push(curr.lessons);
      } else {
        const newTeacherLesson = new TeacherLessons();
        newTeacherLesson.teacher = curr.teacher;
        newTeacherLesson.lessons.push(curr.lessons);
        prev.push(newTeacherLesson);
      }
      return prev;
    }, []);
  }

  get hasStudent() {
    return true;
  }

  private userId!: string;

  nextPage(pageName: string) {
    routeHelper(this, pageName);
  }

  onClick(teacher_user_id: string) {
    if (!Session.isProfielComplete()) {
      MessageDialog.alertModal(`プロフィールを100%入力すると予約が実施できます。`);
      return;
    }

    const dialog: LessonCalendarDialog = this.$refs['LessonCalendarDialog'] as LessonCalendarDialog;
    dialog.show(teacher_user_id);
  }

  deleteItem(class_id: number) {
    const index = this.lessons.findIndex((i) => i.lessons.class_id === class_id);
    this.lessons.splice(index, 1);
  }

  async loadData() {
    this.loading = true;

    const user = Session.get<UserAuthDTO>('USER');
    if (!user) return;
    this.userId = user.user_id!;

    const biz = new LessonsService();
    const start_dt = dayjs().add(-7, 'day').format(DT_FORMAT_INPUT);
    const end_dt = dayjs().add(30, 'day').format(DT_FORMAT_INPUT);
    const respose = await biz.getLessonByStudentIdForCoDashboard(this.userId, start_dt, end_dt);
    this.lessons = respose.data;
    this.loading = false;
  }

  async created() {
    await this.loadData();
  }

  async sendRequest() {
    await this.loadData();
  }

  more(type: string, data: any[]) {
    (this.$refs['NewsAndEventDialog'] as NewsAndEventDialog).show(type, data);
  }

  emergencyMessage(lesson: Lessons) {
    const dialog: EmergencyMessageDialog = this.$refs['emergency-message-dialog'] as EmergencyMessageDialog;
    dialog.show(lesson.class_id!);
  }

  // setup(props: any, context: SetupContext) {
  //   useWebFont(context);
  // }
}
